import { memo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getFormattedDuration } from "@/util/video-player";
import { Form } from "react-bootstrap";

const VideoControlBar = ({
  goFirst,
  handlePrevStep,
  handlePrevFrame,
  handleNextFrame,
  handleNextStep,
  goLast,
  playbackRate,
  playbackRates,
  handleChangeSpeed,
  isPlaying,
  togglePlay,
  muted,
  toggleMute,
  progress,
  videoDuration,
  currentTime,
  labelCurrentTime = currentTime,
  labelCurrentTimeText = null,
  labelDurationText = null,
  startTime,
  endTime,
  timeStamps,
  isLive,
  isFollowingLiveEdge = false,
  progressStartTime = 0,
  onPlayerProgressClick,
}) => {
  const getMarkerLeft = (time) => {
    const percent = ((time - progressStartTime) * 100) / videoDuration;
    return `${Math.min(100, Math.max(0, percent))}%`;
  };
  const progressMax = isLive && isFollowingLiveEdge ? 1 : videoDuration;
  const progressValue = isLive && isFollowingLiveEdge ? 1 : currentTime;

  return (
    <div className="d-flex align-items-center">
      <button
        className="my-1 d-flex justify-content-center align-items-center"
        onClick={goFirst}
        title="First Frame"
      >
        <FontAwesomeIcon icon={["fas", "step-backward"]} />
      </button>
      <button
        className="my-1 d-flex justify-content-center align-items-center"
        onClick={handlePrevStep}
        title="Prev Step [C]"
      >
        <FontAwesomeIcon icon={["fas", "backward"]} />
      </button>
      <button
        className="my-1 d-flex justify-content-center align-items-center"
        onClick={handlePrevFrame}
        title="Prev Frame [D]"
      >
        <FontAwesomeIcon icon={["fas", "chevron-left"]} />
      </button>
      <button
        className="my-1 d-flex justify-content-center align-items-center"
        onClick={togglePlay}
        title={isPlaying ? "Pause [Space]" : "Play [Space]"}
      >
        <FontAwesomeIcon icon={["fas", isPlaying ? "pause" : "play"]} />
      </button>
      <button
        className="my-1 d-flex justify-content-center align-items-center"
        onClick={handleNextFrame}
        title="Next Frame [F]"
      >
        <FontAwesomeIcon icon={["fas", "chevron-right"]} />
      </button>
      <button
        className="my-1 d-flex justify-content-center align-items-center"
        onClick={handleNextStep}
        title="Next Step [V]"
      >
        <FontAwesomeIcon icon={["fas", "forward"]} />
      </button>
      <button
        className="my-1 d-flex justify-content-center align-items-center"
        onClick={goLast}
        title="Last Frame"
      >
        <FontAwesomeIcon icon={["fas", "step-forward"]} />
      </button>
      <Form.Select
        size="sm"
        className="playback-speed-select"
        value={playbackRate}
        onChange={handleChangeSpeed}
      >
        {playbackRates.map((rate) => (
          <option key={rate} value={rate}>
            x{rate}
          </option>
        ))}
      </Form.Select>
      {muted ? (
        <button
          className="my-1 d-flex justify-content-center align-items-center"
          onClick={toggleMute}
          title="Unmute"
        >
          <FontAwesomeIcon icon={["fas", "volume-xmark"]} />
        </button>
      ) : (
        <button
          className="my-1 d-flex justify-content-center align-items-center"
          onClick={toggleMute}
          title="Mute"
        >
          <FontAwesomeIcon icon={["fas", "volume-low"]} />
        </button>
      )}
      <div className="flex-grow-1 mx-2">
        <div className="position-relative triangle-caret-container">
          {startTime !== null && endTime !== null && videoDuration ? (
            <>
              <div
                className="triangle-caret"
                style={{
                  left: getMarkerLeft(startTime),
                }}
              ></div>
              <div
                className="triangle-caret"
                style={{
                  left: getMarkerLeft(endTime),
                }}
              ></div>
              {timeStamps.map(({ time, color }) => (
                <div
                  className="triangle-caret tw-z-50 !tw-top-7 !tw-border-t-0 tw-border-b-[7px] tw-border-solid"
                  style={{
                    left: getMarkerLeft(time),
                    borderBottomColor: color,
                  }}
                ></div>
              ))}
            </>
          ) : null}
        </div>
        <progress
          ref={progress}
          max={progressMax}
          value={progressValue}
          onClick={onPlayerProgressClick}
        />
      </div>
      <div className="video-player-control-bar-time">
        {labelCurrentTimeText ?? getFormattedDuration(labelCurrentTime)} /{" "}
        {labelDurationText ?? (isLive ? "LIVE" : getFormattedDuration(videoDuration))}
      </div>
    </div>
  );
};

export default memo(VideoControlBar);
